var map = {
	"./1_hello.mp3": "9701",
	"./2_bye_bye.mp3": "be97",
	"./4_Lisa.mp3": "3a2a",
	"./6_bear.mp3": "e279",
	"./7_mole.mp3": "e430",
	"./M_Brilliant.mp3": "0b68",
	"./M_Excellent.mp3": "d369",
	"./M_Fantastic.mp3": "da0e",
	"./M_Great.mp3": "0b09",
	"./M_Perfect.mp3": "78f5",
	"./M_Think again.mp3": "c7e0",
	"./M_Try again.mp3": "8552",
	"./M_Very good.mp3": "5145",
	"./M_Well done.mp3": "f560",
	"./M_Work harder.mp3": "682d",
	"./click.mp3": "50b6",
	"./false.mp3": "ac78",
	"./true.mp3": "2ee8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1782";